import { Box, IconButton, Stack, styled } from '@mui/material';
import { LIST_ROW_DIMENSIONS } from '@/constants/layout';

export const ExpandedListRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'hasThumbnail',
})<{ isActive: boolean; hasThumbnail: boolean }>(({ theme, isActive, hasThumbnail }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1.5, 2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',
  minHeight: hasThumbnail ? LIST_ROW_DIMENSIONS.EXPANDED_WITH_THUMBNAIL_HEIGHT : LIST_ROW_DIMENSIONS.EXPANDED_HEIGHT,
  width: '100%',
  boxSizing: 'border-box',
  minWidth: 0,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 2),
    minHeight: 'auto',
  },
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '& .list-row-actions': {
    opacity: isActive ? 1 : 0,
    visibility: isActive ? ('visible' as const) : ('hidden' as const),
    transition: 'opacity 0.2s ease, visibility 0s 0.2s',
    [theme.breakpoints.down('md')]: {
      opacity: 1,
      visibility: 'visible' as const,
    },
  },
  '&:hover .list-row-actions': {
    opacity: 1,
    visibility: 'visible' as const,
    transition: 'opacity 0.2s ease',
  },
}));

export const ThumbnailBox = styled(Box)(() => ({
  width: LIST_ROW_DIMENSIONS.THUMBNAIL_SIZE,
  height: LIST_ROW_DIMENSIONS.THUMBNAIL_SIZE,
  borderRadius: LIST_ROW_DIMENSIONS.THUMBNAIL_BORDER_RADIUS,
  overflow: 'hidden',
  flexShrink: 0,
  marginRight: 12,
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}));

export const RowContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  gap: 2,
  [theme.breakpoints.down('md')]: {
    gap: 6,
  },
}));

export const TagsRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: 4,
  marginTop: 4,
  overflow: 'hidden',
  maxHeight: 24,
  [theme.breakpoints.down('md')]: {
    maxHeight: 'none',
    overflow: 'visible',
  },
}));

export const ActionButtons = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 4,
  flexShrink: 0,
  marginLeft: 8,
});

export const MoreButton = styled(IconButton)(({ theme }) => ({
  padding: 4,
  color: theme.palette.text.secondary,
  '&:hover': {
    color: theme.palette.text.primary,
  },
  '& svg': {
    height: 18,
    width: 18,
  },
}));
